export default "__VITE_ASSET__DeNlaxn0__"